module.exports = __webpack_public_path__ + "static/media/suit-5.9611da41.jpg";